module.exports = __webpack_public_path__ + "static/media/DSC04730.cecbd09f.JPG";